import PublicAdminPanelInstance from "../../api/PublicAdminPanelInstance";

export const REGULATOR_SIGN_IN_PATH = "/admin-panel-regulators/v1/sign-in";
export const REGULATOR_SET_PASSWORD_PATH =
  "/admin-panel-regulators/v1/set-password";

export type RegulatorAuthData = Record<string, unknown>;

export type RegulatorSignInPayload = {
  user_name: string;
  password: string;
};

export type RegulatorSetPasswordPayload = {
  user_name: string;
  session: string;
  new_password: string;
};

export const signInRegulator = async (
  payload: RegulatorSignInPayload,
): Promise<RegulatorAuthData> => {
  const response = await PublicAdminPanelInstance.post(
    REGULATOR_SIGN_IN_PATH,
    payload,
  );
  return response.data.data;
};

export const setRegulatorPassword = async (
  payload: RegulatorSetPasswordPayload,
): Promise<RegulatorAuthData> => {
  const response = await PublicAdminPanelInstance.post(
    REGULATOR_SET_PASSWORD_PATH,
    payload,
  );
  return response.data.data;
};
